// extracted by mini-css-extract-plugin
export default {"container":"w2QgJA","container--mobile":"Bjdf4g","heading":"x_itNu"};